import { createStyles } from 'antd-style'

export const useStyles = createStyles({
  cardContent: {
    padding: '0px 0px 0px 4px',
    marginBottom: '6px',
    overflow: 'hidden'
  },

  collapse: {
    '.ant-collapse-item .ant-collapse-header': {
      padding: 0
    }
  },

  expandButton: {
    opacity: 0,
    transition: 'opacity 0.2s'
  },

  card: {
    cursor: 'grab',
    '.ant-card-body': {
      padding: '8px 8px 8px 4px'
    },
    '&:hover': {
      '& .ant-card-body > div:first-child .ant-row .ant-col:last-child button':
        {
          opacity: 1
        }
    }
  },

  rate: {
    '&.ant-rate': {
      fontSize: 16
    }
  }
})
